export const getEntity = () => {
    return window._extra['tool-date-formatter']?.options?.entity;
};
